import React, { useState } from "react";
import { Button, Form, Collapse, Spinner } from "react-bootstrap";
import { EditIcon } from "../../../assets/icons";
import StatusChip from "../../../components/statusChip/StatusChip";

const CategoryItem = ({
    category,
    onAdd,
    onEdit,
    onDelete,
    onToggleStatus,
    level = 0,
    canCreate,
    canUpdate,
    canDelete
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isToggling, setIsToggling] = useState(false);
    const hasSubCategories = category.subcategories && category.subcategories.length > 0;

    const handleToggle = async (id, status) => {
        setIsToggling(true);
        try {
            await onToggleStatus(id, status);
        } finally {
            setIsToggling(false);
        }
    };

    return (
        <div className="category-item-container" style={{ marginLeft: `${level * 20}px` }}>
            <div className={`category-item d-flex align-items-center justify-content-between p-2 mb-2 rounded border ${category.is_active ? 'bg-light' : 'bg-secondary-subtle text-muted'}`}>
                <div className="d-flex align-items-center gap-2">
                    {hasSubCategories && (
                        <span
                            className="cursor-pointer"
                            onClick={() => setIsOpen(!isOpen)}
                            style={{ width: '20px', textAlign: 'center' }}
                        >
                            {isOpen ? "−" : "+"}
                        </span>
                    )}
                    {!hasSubCategories && <span style={{ width: '20px' }}></span>}
                    <span className="fw-medium">{category.name}</span>
                    <div className="d-flex align-items-center gap-2">
                        <StatusChip
                            bg={category.is_active ? "success" : "danger"}
                            title={category.is_active ? "Active" : "Inactive"}
                            pill
                            size="sm"
                        />
                        {isToggling && (
                            <Spinner
                                animation="border"
                                size="sm"
                                variant="primary"
                                className="ms-1"
                                style={{ width: '0.8rem', height: '0.8rem', borderWidth: '0.15em' }}
                            />
                        )}
                    </div>
                </div>

                <div className="d-flex align-items-center gap-2">
                    {canCreate && (
                        <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() => onAdd(category.id)}
                            disabled={isToggling}
                            title="Add Sub-category"
                        >
                            + Sub
                        </Button>
                    )}
                    {canUpdate && (
                        <Button
                            variant="outline-info"
                            size="sm"
                            onClick={() => onEdit(category)}
                            disabled={isToggling}
                            title="Edit"
                        >
                            <EditIcon width={14} height={14} />
                        </Button>
                    )}
                    <Form.Check
                        type="switch"
                        checked={category.is_active}
                        disabled={isToggling || !canUpdate}
                        onChange={(e) => handleToggle(category.id, e.target.checked)}
                        className="ms-2"
                    />
                    {/* <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => onDelete(category.id)}
                        title="Delete"
                    >
                        <Delete02Icon width={14} height={14} />
                    </Button> */}
                </div>
            </div>

            {hasSubCategories && (
                <Collapse in={isOpen}>
                    <div>
                        {category.subcategories.map((sub) => (
                            <CategoryItem
                                key={sub.id}
                                category={sub}
                                onAdd={onAdd}
                                onEdit={onEdit}
                                onDelete={onDelete}
                                onToggleStatus={onToggleStatus}
                                level={level + 1}
                                canCreate={canCreate}
                                canUpdate={canUpdate}
                                canDelete={canDelete}
                            />
                        ))}
                    </div>
                </Collapse>
            )}
        </div>
    );
};

export default CategoryItem;
